function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { BasePlugin as e } from "@easepick/base-plugin";
import { DateTime as t } from "@easepick/datetime";

var n = /*#__PURE__*/function (_e) {
  _inherits(n, _e);

  var _super = _createSuper(n);

  function n() {
    var _this;

    _classCallCheck(this, n);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.rangePlugin = void 0;
    _this.lockPlugin = void 0;
    _this.priority = 10;
    _this.binds = {
      onView: _this.onView.bind(_assertThisInitialized(_this)),
      onColorScheme: _this.onColorScheme.bind(_assertThisInitialized(_this))
    };
    _this.options = {
      dropdown: {
        months: !1,
        years: !1,
        minYear: 1950,
        maxYear: null
      },
      darkMode: !0,
      locale: {
        resetButton: '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>'
      }
    };
    _this.matchMedia = void 0;
    return _this;
  }

  _createClass(n, [{
    key: "getName",
    value: function getName() {
      return "AmpPlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      this.options.darkMode && window && "matchMedia" in window && (this.matchMedia = window.matchMedia("(prefers-color-scheme: dark)"), this.matchMedia.matches && (this.picker.ui.container.dataset.theme = "dark"), this.matchMedia.addEventListener("change", this.binds.onColorScheme)), this.options.weekNumbers && this.picker.ui.container.classList.add("week-numbers"), this.picker.on("view", this.binds.onView);
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.options.darkMode && window && "matchMedia" in window && this.matchMedia.removeEventListener("change", this.binds.onColorScheme), this.picker.ui.container.removeAttribute("data-theme"), this.picker.ui.container.classList.remove("week-numbers"), this.picker.off("view", this.binds.onView);
    }
  }, {
    key: "onView",
    value: function onView(e) {
      this.lockPlugin = this.picker.PluginManager.getInstance("LockPlugin"), this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin"), this.handleDropdown(e), this.handleResetButton(e), this.handleWeekNumbers(e);
    }
  }, {
    key: "onColorScheme",
    value: function onColorScheme(e) {
      var t = e.matches ? "dark" : "light";
      this.picker.ui.container.dataset.theme = t;
    }
  }, {
    key: "handleDropdown",
    value: function handleDropdown(e) {
      var _this2 = this;

      var _e$detail = e.detail,
          _n = _e$detail.view,
          i = _e$detail.target,
          o = _e$detail.date,
          s = _e$detail.index;

      if ("CalendarHeader" === _n) {
        var _e2 = i.querySelector(".month-name");

        if (this.options.dropdown.months) {
          _e2.childNodes[0].remove();

          var _n8 = document.createElement("select");

          _n8.className = "month-name--select month-name--dropdown";

          for (var _e3 = 0; _e3 < 12; _e3 += 1) {
            var _i = document.createElement("option"),
                _s = new t(new Date(o.getFullYear(), _e3, 2, 0, 0, 0)),
                a = new t(new Date(o.getFullYear(), _e3, 1, 0, 0, 0));

            _i.value = String(_e3), _i.text = _s.toLocaleString(this.picker.options.lang, {
              month: "long"
            }), this.lockPlugin && (_i.disabled = this.lockPlugin.options.minDate && a.isBefore(new t(this.lockPlugin.options.minDate), "month") || this.lockPlugin.options.maxDate && a.isAfter(new t(this.lockPlugin.options.maxDate), "month")), _i.selected = a.getMonth() === o.getMonth(), _n8.appendChild(_i);
          }

          _n8.addEventListener("change", function (e) {
            var t = e.target;
            _this2.picker.calendars[0].setDate(1), _this2.picker.calendars[0].setMonth(Number(t.value)), _this2.picker.renderAll();
          }), _e2.prepend(_n8);
        }

        if (this.options.dropdown.years) {
          _e2.childNodes[1].remove();

          var _n9 = document.createElement("select");

          _n9.className = "month-name--select";

          var _i2 = this.options.dropdown.minYear,
              _s2 = this.options.dropdown.maxYear ? this.options.dropdown.maxYear : new Date().getFullYear();

          if (o.getFullYear() > _s2) {
            var _e4 = document.createElement("option");

            _e4.value = String(o.getFullYear()), _e4.text = String(o.getFullYear()), _e4.selected = !0, _e4.disabled = !0, _n9.appendChild(_e4);
          }

          for (var _e5 = _s2; _e5 >= _i2; _e5 -= 1) {
            var _i3 = document.createElement("option"),
                _s3 = new t(new Date(_e5, 0, 1, 0, 0, 0));

            _i3.value = String(_e5), _i3.text = String(_e5), this.lockPlugin && (_i3.disabled = this.lockPlugin.options.minDate && _s3.isBefore(new t(this.lockPlugin.options.minDate), "year") || this.lockPlugin.options.maxDate && _s3.isAfter(new t(this.lockPlugin.options.maxDate), "year")), _i3.selected = o.getFullYear() === _e5, _n9.appendChild(_i3);
          }

          if (o.getFullYear() < _i2) {
            var _e6 = document.createElement("option");

            _e6.value = String(o.getFullYear()), _e6.text = String(o.getFullYear()), _e6.selected = !0, _e6.disabled = !0, _n9.appendChild(_e6);
          }

          if ("asc" === this.options.dropdown.years) {
            var _e7 = Array.prototype.slice.call(_n9.childNodes).reverse();

            _n9.innerHTML = "", _e7.forEach(function (e) {
              e.innerHTML = e.value, _n9.appendChild(e);
            });
          }

          _n9.addEventListener("change", function (e) {
            var t = e.target;
            _this2.picker.calendars[0].setFullYear(Number(t.value)), _this2.picker.renderAll();
          }), _e2.appendChild(_n9);
        }
      }
    }
  }, {
    key: "handleResetButton",
    value: function handleResetButton(e) {
      var _this3 = this;

      var _e$detail2 = e.detail,
          t = _e$detail2.view,
          _n4 = _e$detail2.target;

      if ("CalendarHeader" === t && this.options.resetButton) {
        var _e8 = document.createElement("button");

        _e8.className = "reset-button unit", _e8.innerHTML = this.options.locale.resetButton, _e8.addEventListener("click", function (e) {
          e.preventDefault();
          var t = !0;
          "function" == typeof _this3.options.resetButton && (t = _this3.options.resetButton.call(_this3)), t && _this3.picker.clear();
        }), _n4.appendChild(_e8);
      }
    }
  }, {
    key: "handleWeekNumbers",
    value: function handleWeekNumbers(e) {
      var _this4 = this;

      if (this.options.weekNumbers) {
        var _e$detail3 = e.detail,
            _n10 = _e$detail3.view,
            i = _e$detail3.target;

        if ("CalendarDayNames" === _n10) {
          var _e9 = document.createElement("div");

          _e9.className = "wnum-header", _e9.innerHTML = "Wk", i.prepend(_e9);
        }

        "CalendarDays" === _n10 && _toConsumableArray(i.children).forEach(function (e, _n6) {
          if (0 === _n6 || _n6 % 7 == 0) {
            var _n11;

            if (e.classList.contains("day")) _n11 = new t(e.dataset.time);else {
              var _e10 = i.querySelector(".day");

              _n11 = new t(_e10.dataset.time);
            }

            var o = _n11.getWeek(_this4.picker.options.firstDay);

            53 === o && 0 === _n11.getMonth() && (o = "53/1");
            var s = document.createElement("div");
            s.className = "wnum-item", s.innerHTML = String(o), i.insertBefore(s, e);
          }
        });
      }
    }
  }]);

  return n;
}(e);

export { n as AmpPlugin };